import L from 'leaflet';
import React from 'react';
import { MarkerIconProps, MarkerPointType, MarkerWorldMapEventType } from '../../types/map';
import { renderToString } from 'react-dom/server';
import { PointMarkerIcon } from './PointMarkerIcon';
import { EventsWorldMapMarkerIcon } from './EventsWorldMapMarkerIcon';
import { PoiAccessTypeEnum } from '@utmb/types/enum/PoiAccessTypeEnum';

const MapIcon: any = L.Icon.extend({
    options: {
        iconUrl: '',
        shadowUrl: '/map-markers/marker-shadow.png',
        iconSize: [60, 60],
        shadowSize: [45, 63],
        iconAnchor: [30, 59],
        shadowAnchor: [22, 60],
        popupAnchor: [0, -68],
    },
});

const MapIconNoShadow: any = L.Icon.extend({
    options: {
        iconUrl: '',
        shadowUrl: '',
        iconSize: [60, 60],
        iconAnchor: [30, 59],
        popupAnchor: [0, -68],
    },
});

const MarkerIcon = ({ type, color, eventView, isOpen }: MarkerIconProps) => {
    const isPoint = ['point-start', 'point-finish', 'point-segment', 'point'].includes(type);
    const isWorldMapEvent = type === 'world-map-event';

    if (isPoint) {
        return L.divIcon({
            html: renderToString(<PointMarkerIcon color={color} type={type as MarkerPointType} />),
            iconSize: [24, 24],
            iconAnchor: [12, 12],
            popupAnchor: [0, 0],
            className: 'leaflet-marker-shadow',
        });
    } else if (isWorldMapEvent && eventView) {
        return L.divIcon({
            html: renderToString(<EventsWorldMapMarkerIcon color={color} type={type as MarkerWorldMapEventType} eventView={eventView} isOpen={isOpen} />),
            iconSize: [255, 100],
            iconAnchor: [75, 70],
            popupAnchor: [0, -40],
            className: 'leaflet-marker-shadow',
        });
    } else if(type === PoiAccessTypeEnum.EVENT) {
        return new MapIconNoShadow({ iconUrl: `/map-markers/marker-${type}.svg` });
    } else {
        return new MapIcon({ iconUrl: `/map-markers/marker-${type}.svg` });
    }
};

export default MarkerIcon;
